import React from 'react'
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, View } from 'react-native';
import * as eva from '@eva-design/eva';
import { ApplicationProvider, IconRegistry, Layout, Text } from '@ui-kitten/components';
import { default as mapping } from './mapping.json'; // <-- Import app mapping
import { default as theme } from './theme.json'; // <-- Import app theme

import { useFonts } from 'expo-font';
import { I18nManager } from "react-native";
import FlashMessage from "react-native-flash-message";
import { EvaIconsPack } from '@ui-kitten/eva-icons';
import { Provider } from 'react-redux';
import { createStore, combineReducers} from 'redux';
import { AppNavigator } from './navigation.component';
import dashboardReducer from './store/reducers/dashboard'

import * as ScreenOrientation from 'expo-screen-orientation';

export default function App() {
  // FORCE RIGHT TO LEFT APP
 React.useEffect(()=>{
        I18nManager.forceRTL(true);
        I18nManager.allowRTL(true);

// ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE_LEFT);
    },[])

    const [fontsLoaded] = useFonts({
     'IRANYekan': require('./assets/fonts/IRANYekanMobile.ttf'),
     'IRANYekanBold': require('./assets/fonts/IRANYekanMobile-Bold.ttf'),
   });
   if(!fontsLoaded){
     return null;
   }
   const rootReducer = combineReducers({
     dashboard: dashboardReducer
        });
        const store = createStore(rootReducer);


  return (
     <Provider
     store={store}
     >
     <IconRegistry icons={EvaIconsPack} />
	<ApplicationProvider {...eva} theme={{...eva.light, ...theme}}
  customMapping={mapping}>


     <AppNavigator />
  </ApplicationProvider>
  <FlashMessage
   position="top"
   statusBarHeight={30}
   textStyle={{fontFamily:'IRANYekanBold'}}
   titleStyle={{fontFamily:'IRANYekanBold'}}
  />
  </Provider>

  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
